module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseWidget', [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("dashboardModule.myOrdersTitle")))]), _vm._v(" "), _c('template', {
    slot: "content-desktop"
  }, [_c('OrderList')], 1), _vm._v(" "), _c('template', {
    slot: "content-mobile"
  }, [_c('OrderList')], 1), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('LinkButton', {
    attrs: {
      "to": '/orders',
      "text": _vm.$t('dashboardModule.seeAllOrders')
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b7165a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/MyOrdersWidget.vue
// module id = 3225
// module chunks = 0